export default __webpack_public_path__ + "static/media/Logo_placeholder.60190fed.svg";